import { render } from "./dialog.component.vue?vue&type=template&id=1996d156&scoped=true&ts=true"
import script from "./dialog.component.vue?vue&type=script&lang=ts"
export * from "./dialog.component.vue?vue&type=script&lang=ts"

import "./dialog.component.vue?vue&type=style&index=0&id=1996d156&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1996d156"]])

export default __exports__